import type { BadgeVariant } from '@/components/ui/Badge';

/**
 * Maps the risco/severidade enums shared by Guardião da Disputa (E.2) and
 * Auditor 360° (E.4/base) to the design system's Badge color tokens.
 */
export function riscoBadgeVariant(nivel: string): BadgeVariant {
  switch (nivel) {
    case 'baixo':
    case 'baixa':
      return 'success';
    case 'medio':
    case 'media':
      return 'warning';
    case 'alto':
    case 'alta':
    case 'critico':
    case 'critica':
      return 'danger';
    default:
      return 'default';
  }
}

export function conformidadeStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'atende':
      return 'success';
    case 'nao_atende':
      return 'danger';
    case 'parcial':
      return 'warning';
    case 'nao_se_aplica':
    default:
      return 'default';
  }
}
